import RedirectNoticeModal from './redirect-notice-modal.jsx';

export default RedirectNoticeModal;
